import React from "react";
import { header } from "react-bootstrap";
import "./HomeHead.css";
import * as Constants from "../../../_constants/accessoryfinder.constants";
import Accessories from "./Accessories/Accessories";
import VacuumModel from "./VacuumModel/VacuumModel";

const HomeHead = (props) => {
  return (
    <header className="masthead img-fluid" id="home">
      <div className="masthead-overlay" />
      <div className="container h-100">
        <h4 className="bg-text-title">I am looking for</h4>
        <div className="bg-text-subTitle">
          <div>
            <div className="form-check form-check-inline">
              <input
                className="form-radio"
                type="radio"
                name="rdbAccessories"
                value={Constants.ACCESSORIES}
                checked={props.checkedValue === Constants.ACCESSORIES}
                onChange={props.onRadioChange}
              />
              <label
                className="form-check-label"
                htmlFor="inlineRadio2"
                onClick={() => props.labelClick(Constants.ACCESSORIES)}
              >
                Accessories
              </label>
            </div>
            <div className="form-check form-check-inline">
              <input
                className="form-radio"
                type="radio"
                name="rdbVacuumModel"
                value={Constants.VACUUMMODEL}
                checked={props.checkedValue === Constants.VACUUMMODEL}
                onChange={props.onRadioChange}
              />
              <label
                className="form-check-label"
                htmlFor="inlineRadio1"
                onClick={() => props.labelClick(Constants.VACUUMMODEL)}
              >
                Vacuum Model
              </label>
            </div>
          </div>
        </div>
        <div className="row align-items-center">
          <div className="col-12 text-center">
            {props.isAccessories ? (
              <Accessories {...props} />
            ) : (
              <VacuumModel {...props} />
            )}
          </div>
        </div>
      </div>
    </header>
  );
};
export default HomeHead;
